<template>
  <div>
    <div class="screen">
      <el-form :inline="true" >
        <el-row >
          <el-col :md="6">
            <el-form-item label="患儿姓名">
              <el-input type="text" size="small" placeholder="请输入" v-model="search.searchCond.childName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="6">
            <el-form-item label="救助医院">
              <HospitalSelect v-model="search.searchCond.hospitalId" :all="false"></HospitalSelect>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <SearchButton @search="filtrate" @reset="reset" @expand="e => openScreen1 = e"></SearchButton>
          </el-col>
        </el-row>
        <el-row v-show="openScreen1">
          <el-col :md="6">
            <el-form-item label="申请编号">
              <el-input type="text" size="small" placeholder="请输入" v-model="search.searchCond.helpId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="6">
            <el-form-item label="病 种">
              <DiseaseCascader v-model="search.searchCond.diseasesId" :hospitalId="search.searchCond.hospitalId"></DiseaseCascader>
            </el-form-item>
          </el-col>
          <el-col :md="6">
            <el-form-item label="申请时间">
              <DateRangePicker v-model="search.searchCond.requestTimeRange">
              </DateRangePicker>
            </el-form-item>
          </el-col>
          <el-col :md="6">
            <el-form-item label="户口所在地">
              <LocationCascader v-model="location" :checkStrictly="true" @change="changeLoaction"></LocationCascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="openScreen1">
          <el-col :md="6">
            <el-form-item label="出生日期">
              <DateRangePicker v-model="search.searchCond.birthdayRange">
              </DateRangePicker>
            </el-form-item>
          </el-col>
          <el-col :md="6">
            <el-form-item label="所属项目">
              <DictionarySelect v-model="search.searchCond.initialProject" tableCode="PROJECT_NAME" placeholder="请选择" :lazy="true">
              </DictionarySelect>
            </el-form-item>
          </el-col>
          <el-col :md="6">
            <el-form-item label="身份证号">
              <el-input type="text" size="small" placeholder="请输入" v-model="search.searchCond.idNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="6" v-if="active == 'fiveth'">
            <el-form-item label="救助状态">
              <DictionarySelect v-model="search.searchCond.apprStatus" tableCode="APPROVE_STATUS" placeholder="请选择" :lazy="true" :excludeKeys="['5']">
              </DictionarySelect>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-table :data="tableData" style="width: 100%"  v-loading="loading" :border="false" height='calc(100vh - 295px)'>
      <el-table-column width="145" label="申请编号" fixed="left">
        <template slot-scope="scope">
          <span class="link" @click="toDetail(scope.row)">{{scope.row.helpId}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="apprTime" label="申请时间" width="100" fixed="left">
        <template slot-scope="scope">
          {{ parseTime(scope.row.requestTime, '{y}-{m}-{d}')}}
        </template>
      </el-table-column>
      <el-table-column prop="childName" width="110"  label="患儿姓名" fixed="left">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.childName"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column prop="hospitalName" label="救助医院" width="160">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.hospitalName"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column prop="diseasesNameSet"  label="病种" width="160">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.diseasesNameSet"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column prop="initialProjectName" label="所属项目" width="80">
      </el-table-column>
      <el-table-column prop="type" align="center" label="期次" width="50">
        <template v-slot="scope">
          {{scope.row.curStages + '/' + (scope.row.initialProject == 'AY1002' ? '-' : (scope.row.totalStages || '-'))}}
        </template>
      </el-table-column>
      <el-table-column v-if="active == 'fiveth'" prop="isSpecialPatient" label="特患" width="50">
        <template slot-scope="scope">
          <span v-if="scope.row.isSpecialPatient">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="birthday" label="出生日期" width="100">
        <template slot-scope="scope">
          {{ parseTime(scope.row.birthday, '{y}-{m}-{d}')}}
        </template>
      </el-table-column>
      <el-table-column prop="sexText" label="性别" width="50">
      </el-table-column>
      <el-table-column prop="status" width="170" label="户口所在地">
        <template slot-scope="scope">
          <TableCellWordBreak :content="(scope.row.provinceText || '') + (scope.row.cityText || '')"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column prop="idNumber" width="170" label="身份证号">
        <template slot-scope="scope">
          {{scope.row.idNumber ? scope.row.idNumber : '-'}}
        </template>
      </el-table-column>
      <el-table-column prop="apprStatusText" label="救助状态">
      </el-table-column>
    </el-table>
    <Pageination @sizeChange="changePageSize" @currentChange="changePage" :currentPage="search.pageNO" :total="total"></Pageination>
  </div>
</template>

<script>
  import {
    getHelpStagesApi
  } from '@/util/api.js'
  import DiseaseCascader from "@/components/business/DiseaseCascader"
  import TableCellWordBreak from "@/components/business/TableCellWordBreak"
  import DateRangePicker from "@/components/business/DateRangePicker"
  import HospitalSelect from "@/components/business/HospitalSelect"
  import DictionarySelect from "@/components/business/DictionarySelect"
  import LocationCascader from "@/components/business/LocationCascader"
  import Pageination from "@/components/business/Pageination";
  import SearchButton from "@/components/business/SearchButton";
  import {getDataListByCondFq} from "../../../util/api";
  export default {
    components: {
      DiseaseCascader,
      TableCellWordBreak,
      DateRangePicker,
      HospitalSelect,
      DictionarySelect,
      LocationCascader,
      SearchButton,
      Pageination
    },
    props: ['status', 'active'],
    data() {
      return {
        openScreen1: false,
        tableData: [],
        isHospital:'false',
        loading: true,
        total: 0,
        location: [],
        diseasesList: null,
        search: {
          "searchCond": {
            "helpReqId": null, //救助申请ID
            "helpId": null, //救助ID
            "excludeHelpId": null, //排除的救助ID
            "childName": null, //患儿姓名
            "birthdayBegin": null, //出生日期（开始）
            "birthdayEnd": null, //出生日期（结束）
            "diseasesId": null, //病种
            "hospitalId": null, //救助医院
            "idNumber": null, //身份证号
            "province": null, //所在省
            "city": null, //所在市
            "county": null, // 所在区县
            "requestTimeBegin": null, //申请时间（开始）
            "requestTimeEnd": null, //申请时间（结束）
            "apprStatus": null, //救助状态
            "apprTimeBegin": null, //审核时间（开始）
            "apprTimeEnd": null, //审核时间（结束）
            "outlayStatus": null, //费用状态
            "protocolStatus": null, //协议状态
            "isTimeout": null, //是否超期患儿
            "specialFlag": null, //特殊标记（1=公益宝贝，2=三区三州）
            "isSpecialPatient": null, //是否特患
            initialProject: null, //初始项目
            forApprOnly: 1,
            helpStatus: 1 // 只查询已提交的申请
          },
          "orderBy": "createAt desc",
          "pageNO": 1,
          "pageSize": 10
        }
      }
    },
    created() {
      this.getHelpStages()
      this.isHospital = window.localStorage.getItem("hospAccount")
    },
    watch: {
      '$route.query.q' : {
        deep: true,
        handler () {
          this.getHelpStages();
          this.isHospital = window.localStorage.getItem("hospAccount")
        }
      }
    },
    methods: {
      // 选择地址
      changeLoaction(e) {
        this.search.searchCond.province = e[0] //所在省
        this.search.searchCond.city = e[1] //所在市
        this.search.searchCond.county = e[2] // 所在区县
      },
      getHelpStages() {
        if (this.search.searchCond.requestTimeRange && this.search.searchCond.requestTimeRange.length > 1) {
          this.search.searchCond.requestTimeBegin = this.search.searchCond.requestTimeRange[0];
          this.search.searchCond.requestTimeEnd = this.search.searchCond.requestTimeRange[1];
        } else {
          this.search.searchCond.requestTimeBegin = null;
          this.search.searchCond.requestTimeEnd = null;
        }
        if (this.search.searchCond.birthdayRange && this.search.searchCond.birthdayRange.length > 1) {
          this.search.searchCond.birthdayBegin = this.search.searchCond.birthdayRange[0];
          this.search.searchCond.birthdayEnd = this.search.searchCond.birthdayRange[1];
        } else {
          this.search.searchCond.birthdayBegin = null;
          this.search.searchCond.birthdayEnd = null;
        }
        let params = Object.assign({
          ...this.search.searchCond,
          apprStatus: this.search.searchCond.apprStatus || this.status
        })
        params.apprStatus = params.apprStatus == 1 ? '1' : params.apprStatus;
        getDataListByCondFq({
          ...this.search,
          searchCond: params
        }).then(res => {
          if (res.msgCode == 200) {
            this.tableData = res.responseData.modelData
            this.total = res.responseData.total
            this.loading = false
          } else {
            this.$message.error()
          }
        }).catch()
      },
      changePage(e) {
        this.loading = true
        this.search.pageNO = e
        this.getHelpStages()
      },

      changePageSize(e) {
        this.loading = true
        this.search.pageSize = e
        this.getHelpStages()
      },

      // 筛选
      filtrate() {
        this.loading = true
        this.getHelpStages()
      },

      // 重置
      reset() {
        this.location = [];
        this.diseasesList = null;
        this.search = {
          "searchCond": {
            "helpReqId": null, //救助申请ID
            "helpId": null, //救助ID
            "excludeHelpId": null, //排除的救助ID
            "childName": null, //患儿姓名
            "birthdayBegin": null, //出生日期（开始）
            "birthdayEnd": null, //出生日期（结束）
            "diseasesId": null, //病种
            "hospitalId": null, //救助医院
            "idNumber": null, //身份证号
            "province": null, //所在省
            "city": null, //所在市
            "county": null, // 所在区县
            "requestTimeBegin": null, //申请时间（开始）
            "requestTimeEnd": null, //申请时间（结束）
            "apprStatus": null, //救助状态
            "apprTimeBegin": null, //审核时间（开始）
            "apprTimeEnd": null, //审核时间（结束）
            "outlayStatus": null, //费用状态
            "protocolStatus": null, //协议状态
            "isTimeout": null, //是否超期患儿
            "specialFlag": null, //特殊标记（1=公益宝贝，2=三区三州）
            "isSpecialPatient": null, //是否特患
            forApprOnly: 1,
            helpStatus: 1 // 只查询已提交的申请
          },
          "orderBy": "create_at desc",
          "pageNO": "1",
          "pageSize": "10"
        }
        this.filtrate();
      },
      toDetail(item) {
        this.$router.push({
          path: '/child/childShDetail',
          query: {
            helpId: item.helpId,
            childUid: item.childUid,
            helpReqId:item.helpReqId
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
 @import "src/common/common";
 @import "src/common/form";
</style>



// WEBPACK FOOTER //
// src/pages/child/audit/ChildAuditTable.vue